import { Box, Column, Row, Tab, TabPanel, Tabs } from '@tempmee/react';
import { useMediaQuery } from '~/hooks';
import { AuthLeftPanel, ProfessionalsTab, TESTIMONIALS, VALUE_PROPS } from '../shared';
import { LoginForm } from './LoginForm';

const HEADLINE = { lineOne: 'The Right Fit', lineTwo: 'Right Now' } as const;

// DS Row has no minHeight prop — fills viewport minus 64px header
const PAGE_STYLE = { minHeight: 'calc(100vh - 64px)' } as const;
// DS Column has no flex or minWidth props — left panel fills remaining space; minWidth:0 prevents flex blowout
const LEFT_PANEL_STYLE = { flex: 1, minWidth: 0 } as const;
// DS Row has no flex prop — form panel fills remaining space
const FORM_PANEL_STYLE = { flex: 1 } as const;
// DS Box has no maxWidth prop — caps form width on narrow screens
const FORM_BOX_STYLE = { maxWidth: '100%' } as const;

export const LoginPage = () => {
  const [isNarrow] = useMediaQuery(['sm']);

  return (
    <Row width="100%" align="stretch" style={PAGE_STYLE} data-testid="login-page">
      {!isNarrow && (
        <Column style={LEFT_PANEL_STYLE}>
          <AuthLeftPanel headline={HEADLINE} valueProps={VALUE_PROPS} testimonials={TESTIMONIALS} />
        </Column>
      )}
      <Row align="start" justify="center" pt={16} pb={10} px={10} style={FORM_PANEL_STYLE}>
        <Box width="448px" style={FORM_BOX_STYLE}>
          <Tabs defaultValue="offices">
            <Row justify="center" style={{ width: '100%', gap: 16 }}>
              <Tab data-cy="tab-offices" value="offices" label="Offices" />
              <Tab data-cy="tab-professionals" value="professionals" label="Professionals" />
            </Row>
            <TabPanel value="offices">
              <LoginForm />
            </TabPanel>
            <TabPanel value="professionals">
              <ProfessionalsTab variant="login" />
            </TabPanel>
          </Tabs>
        </Box>
      </Row>
    </Row>
  );
};
